import { CantileverButton } from 'components/CantileverButton'
import { Minus, Plus, Scan } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

const ZoomControlsContainer = styled.div`
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  z-index: 10;
`

const GlassBg = styled.div`
  background-color: color-mix(
    in oklch,
    ${(props) => props.theme.forecast.pageBackground1},
    transparent 20%
  );
  backdrop-filter: blur(2rem);
  border-radius: 0.25rem;
`

const PlusMinusContainer = styled(GlassBg)`
  display: flex;
  flex-direction: column;
  gap: 0px;
`

interface ZoomControlsProps {
  onZoomIn: () => void
  onZoomOut: () => void
  onResetZoom: () => void
  disabled?: boolean
  zoomOutDisabled?: boolean
  zoomInDisabled?: boolean
}

const PlusButton = styled(CantileverButton)`
  border-radius: 0.25rem 0.25rem 0 0;
  border-bottom: 1px solid
    ${(props) => props.theme.forecast.cardDividerBackground};
`

const MinusButton = styled(CantileverButton)`
  border-radius: 0 0 0.25rem 0.25rem;
`

export const ZoomControls: React.FC<ZoomControlsProps> = ({
  onZoomIn,
  onZoomOut,
  onResetZoom,
  disabled = false,
  zoomOutDisabled = false,
  zoomInDisabled = false,
}) => {
  return (
    <ZoomControlsContainer>
      <PlusMinusContainer>
        <PlusButton
          iconOnly
          ghost
          disabled={disabled || zoomInDisabled}
          onClick={onZoomIn}
          title='Zoom In'>
          <Plus width={20} height={20} />
        </PlusButton>
        <MinusButton
          iconOnly
          ghost
          disabled={disabled || zoomOutDisabled}
          onClick={onZoomOut}
          title='Zoom Out'>
          <Minus width={20} height={20} />
        </MinusButton>
      </PlusMinusContainer>
      <GlassBg>
        <CantileverButton
          iconOnly
          ghost
          disabled={disabled}
          onClick={onResetZoom}
          title='Reset Zoom'>
          <Scan width={20} height={20} />
        </CantileverButton>
      </GlassBg>
    </ZoomControlsContainer>
  )
}
